import { FC, memo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, Table } from 'ui/components/Table'
import { AdverseMediaListResponseItem } from '~bank-adverse-media/types'

import { useAdverseMediaListContext } from '../../context/AdverseMediaListContext'
import { columns } from './columns'

export const AdverseMediaListTable: FC = memo(() => {
  const { data, isPending, state, navigate, redirect } = useAdverseMediaListContext()

  const dataSource: DataSourceItem<AdverseMediaListResponseItem>[] = data.items.map((item) => ({
    item,
    rowProps: { errorHighlight: item.riskLevel === 'Unknown' }
  }))

  return (
    <Table<AdverseMediaListResponseItem>
      dataQa={TableDataQa.ADVERSE_MEDIA_LIST}
      columns={columns(redirect)}
      dataSource={dataSource}
      loading={isPending}
      pagination={{
        page: state.page,
        size: state.size,
        onChange: (page: number, size: number) => {
          navigate({ ...state, page, size })
        },
        total: data.total
      }}
    />
  )
})
